import { twMerge } from "tailwind-merge"
import { ReactComponent as Plus } from "../../assets/icons/plus.svg";
import { ReactComponent as Check } from "../../assets/icons/check-circle-2-1.svg";
import IconButton from "../../base-components/IconButton";

// Shows the actual captured photo once a side is done — not just a checkmark
// — so the driver can see at a glance whether the shot looks right without
// re-opening the camera.
const SidesButton = ({ className, isIncluded, image, onClick }) => {
  if (isIncluded && image) {
    return (
      <div className={twMerge(["absolute", className])}>
        <button
          type="button"
          onClick={onClick}
          className="relative h-12 w-12 rounded-full overflow-hidden border-2 border-secondary shadow-sm outline-none transition-transform duration-150 ease-out [&:active]:scale-90 focus-visible:shadow-focus"
        >
          <img src={image} alt="captured" className="h-full w-full object-cover" />
          <span className="absolute -bottom-0.5 -right-0.5 flex h-5 w-5 items-center justify-center rounded-full bg-secondary border-2 border-white">
            <Check className="h-2.5 w-2.5" fill="#fff" />
          </span>
        </button>
      </div>
    );
  }

  return (
    <div className={twMerge(["absolute", className])}>
      <IconButton variant="primary-outlined" className="border-dark-12" onClick={onClick}>
        <Plus />
      </IconButton>
    </div>
  )
}

export default SidesButton;
